exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-box {\n  display: flex;\n  align-items: center;\n  background-color: #fbf5f5;\n  border: 1px solid #e07c7c;\n  color: #e07c7c;\n  border-radius: 5px;\n  max-height: 95px;\n}\n\n.error-icon {\n  max-height: 60px;\n  margin: 18px 14px 18px 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/ErrorBox/main.css
// module id = 417
// module chunks = 0